/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { PreviewGuard } from "./preview-guard";
import { StageGuard } from "./stage-guard";
import { PreviewBanner } from "./preview-banner";
import { StageBanner } from "./stage-banner";
import { LiveGuard } from "./live-guard";

const EnvWrapper = (props) => {

    const children = props?.children;

    return (
        <>
            <PreviewGuard>
                <PreviewBanner>
                    {children}
                </PreviewBanner>
            </PreviewGuard>

            <StageGuard>
                <StageBanner>
                    {children}
                </StageBanner>
            </StageGuard>

            <LiveGuard>
                {children}
            </LiveGuard>

        </>
    );
};

export { EnvWrapper };
